/**
 * The finish (docs/HINTS-LAYOUT-TUTORIAL.md B8): Tibbs celebrates, "You’re
 * ready.", and Play (home with the Play sheet open) or Replay tutorial.
 */
import { useEffect, useMemo } from 'react';
import type { CSSProperties } from 'react';
import { SHORT_LINE } from '../brand';
import { Tibbs } from '../components/Art';
import { reducedMotion } from '../lib/motion';
import { navigate } from '../lib/router';
import { sfx } from '../lib/sound';
import { OPEN_PLAY } from './keys';

function Leaves() {
  const bits = useMemo(
    () =>
      Array.from({ length: 12 }, (_, i) => ({
        left: 4 + Math.random() * 92,
        delay: Math.random() * 0.6,
        dur: 1.2 + Math.random() * 0.8,
        size: 10 + Math.random() * 8,
        rot: Math.random() * 360,
        gold: i % 3 === 0,
      })),
    [],
  );
  return (
    <div className="laurels tut-leaves" aria-hidden="true">
      {bits.map((b, i) => (
        <span
          key={i}
          className={`leaf${b.gold ? ' gold' : ''}`}
          style={{ left: `${b.left}%`, animationDelay: `${b.delay}s`, animationDuration: `${b.dur}s`, width: b.size, height: b.size * 0.5, '--r': `${b.rot}deg` } as CSSProperties}
        />
      ))}
    </div>
  );
}

export function TutorialFinish({ onReplay }: { onReplay: () => void }) {
  const reduced = reducedMotion();
  useEffect(() => {
    sfx.win();
  }, []);
  const play = () => {
    try {
      sessionStorage.setItem(OPEN_PLAY, '1');
    } catch {
      /* storage blocked: home without the sheet */
    }
    navigate({ name: 'home' });
  };
  return (
    <div className="tut-finish" role="dialog" aria-modal="true" aria-labelledby="tut-finish-title">
      {!reduced && <Leaves />}
      <div className="tut-finish-col">
        <Tibbs pose="celebrate" size={128} className="tut-finish-tibbs" />
        <h1 className="tut-finish-title" id="tut-finish-title">
          You’re ready.
        </h1>
        <p className="tut-finish-line">{SHORT_LINE}</p>
        <button type="button" className="btn btn-gold btn-big wide-btn" onClick={play} autoFocus>
          Play
        </button>
        <button type="button" className="btn btn-quiet wide-btn" onClick={onReplay}>
          Replay tutorial
        </button>
      </div>
    </div>
  );
}
